import { Injectable } from '@angular/core';
import {
  EntityState,
  EntityStore,
  getEntityType,
  MultiActiveState,
  StoreConfig,
} from '@datorama/akita';

import { listSiteContactsQuery, Site } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type SiteModel = getEntityType<SitesState>;

export interface SitesState
  extends EntityState<
      Omit<RequireSome<Partial<Site>, 'id'>, 'managed_by'> & {
        investigator?: listSiteContactsQuery | null;
        managed_by_id?: null | string;
      }
    >,
    MultiActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sites' })
export class SitesStore extends EntityStore<SitesState> {
  constructor() {
    super({});
  }
}
